import dotProp from 'dot-prop-immutable';

import {
    CLEAR_BROKERCOMPANY_SIGNUP,
    REDUCE_BROKER_COMPANY_SIGNUP_TEMPLATE,
    REDUCE_BROKER_COMPANY_SIGNUP_VALIDATION_INFO,
    REDUCE_BROKERCOMPANY_SIGNUP_ELEMENT,
    REDUCE_SETUP_INTENT_CLIENT_SECRET,
} from '../../constants/actions/brokerCompanySignup';

export const initialState = {
    brokerCompanySignup: {},
    template: null,
    validationInfo: null,
    setupIntentClientSecret: null,
};

function brokerCompanySignupReducer(state = initialState, action) {
    switch (action.type) {
        case CLEAR_BROKERCOMPANY_SIGNUP:
            return dotProp.set(state, 'brokerCompanySignup', {});
        case REDUCE_BROKERCOMPANY_SIGNUP_ELEMENT:
            return dotProp.set(state, `brokerCompanySignup.${action.payload.code}`, action.payload.value);
        case REDUCE_BROKER_COMPANY_SIGNUP_TEMPLATE:
            return dotProp.set(state, 'template', action.payload);
        case REDUCE_BROKER_COMPANY_SIGNUP_VALIDATION_INFO:
            return dotProp.set(state, 'validationInfo', action.payload);
        case REDUCE_SETUP_INTENT_CLIENT_SECRET:
            return dotProp.set(state, 'setupIntentClientSecret', action.payload);
        default:
            return state;
    }
}

export default brokerCompanySignupReducer;
